import $ from 'jquery';

$.ajaxSetup({
  cache: true,
});

window.$ = window.jQuery = $;

export default $;
